import chroma from 'chroma-js';
import _ from 'lodash';

export const colors = [
  { color: '#f44336', name: 'red', contrastColor: '#0d083c' },
  { color: '#E91E63', name: 'pink', contrastColor: '#010434' },
  { color: '#9C27B0', name: 'purple', contrastColor: '#dafa69' },
  { color: '#673AB7', name: 'deep purple', contrastColor: '#8ff66d' },
  { color: '#3F51B5', name: 'indigo', contrastColor: '#9eee3f' },
  { color: '#2196F3', name: 'blue', contrastColor: '#041547' },
  { color: '#03A9F4', name: 'light blue', contrastColor: '#2e3824' },
  { color: '#00BCD4', name: 'cyan', contrastColor: '#541b87' },
  { color: '#009688', name: 'teal', contrastColor: '#210547' },
  { color: '#4CAF50', name: 'green', contrastColor: '#270d0b' },
  { color: '#8BC34A', name: 'light green', contrastColor: '#4a19ba' },
  // { color: '#CDDC39', name: 'lime', contrastColor: '#48266e' },
  // { color: '#FBC02D', name: 'yellow', contrastColor: '#382ecc' },
  // { color: '#FFC107', name: 'amber', contrastColor: '#5c3771' },
  { color: '#FF9800', name: 'orange', contrastColor: '#36220c' },
  { color: '#FF5722', name: 'deep orange', contrastColor: '#0c1e40' },
  { color: '#795548', name: 'brown', contrastColor: '#e7f77f' },
  { color: '#607D8B', name: 'blue grey', contrastColor: '#040129' },
];

export const random = () => {
  return colors[Math.floor((Math.random() * colors.length))];
};

export const getColorByString = (myString) => {
  const numericValues = Array.prototype.map.call(myString, (e) => { return e.charCodeAt(0); });
  const totalValue = _.sum(numericValues);

  return colors[totalValue % colors.length].color;
};

export const hexToRgb = (hexadecimal) => {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  const hex = hexadecimal.replace(shorthandRegex, (m, r, g, b) => (
    r + r + g + g + b + b
  ));

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16),
  } : null;
};

export const hexToRgbString = (hexadecimal) => {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  const hex = hexadecimal.replace(shorthandRegex, (m, r, g, b) => (
    r + r + g + g + b + b
  ));

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}` : null;
};

export const getDarkerColor = (hexadecimal, darker = 50) => {
  const rgb = hexToRgb(hexadecimal);
  let { r, g, b } = rgb;
  r = Math.max(0, r - darker);
  g = Math.max(0, g - darker);
  b = Math.max(0, b - darker);

  return { r, g, b };
};

export const getLighterColor = (hexadecimal, lighter = 25) => {
  const rgb = hexToRgb(hexadecimal);
  let { r, g, b } = rgb;
  r = Math.min(255, r + lighter);
  g = Math.min(255, g + lighter);
  b = Math.min(255, b + lighter);

  return { r, g, b };
};


const componentToHex = (c) => {
  const hex = c.toString(16);
  return hex.length === 1 ? `0${hex}` : hex;
};

export const rgbToHex = ({ r, g, b }) => {
  return `#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}`;
};

export const invertColor = (color) => {
  let maxLoops = 5000;
  let randomColor = chroma.random();
  let contrast = chroma.contrast(randomColor, color);
  while (maxLoops > 0 && contrast <= 7) {
    maxLoops -= 1;
    const aux = chroma.random();
    const auxContrast = chroma.contrast(aux, color);
    if (auxContrast > contrast) {
      contrast = auxContrast;
      randomColor = aux;
    }
  }
  return randomColor;
};

export const hsl = (color) => {
  return chroma(color).hsl();
};

export const getBrightness = (r, g, b) => {
  return (r * 299 + g * 587 + b * 114) / 1000;
};

export const getContrastColor = (color) => {
  const hex = hexToRgb(color);

  let textColor = 'rgba(0, 0, 0, 0.54)';

  const brightness = getBrightness(hex.r, hex.b, hex.g);
  if (brightness < 180) {
    textColor = 'rgb(255, 255, 255)';
  }

  return textColor;
};



// WEBPACK FOOTER //
// ./src/utils/colors.js